import styled from 'styled-components';
import { Base } from 'styled';
import { Props } from './index';

type DropdownContainerProps = Pick<Props, 'showError' | 'color'>;

export type LabelProps = {
  showLabel: boolean;
};

export const Label = styled(Base)<LabelProps>`
  ${({ theme }) => theme.typography.variants.primary.xs};
  ${({ theme }) => theme.transitions['transition-short']};
  opacity: ${({ showLabel }) => (showLabel ? 1 : 0)};
`;

export const ErrorMessage = styled(Label)`
  color: ${({ theme }) => theme.colors.red};
`;

export const DropdownContainer = styled(Base).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['color'].includes(prop) && defaultValidatorFn(prop),
})<DropdownContainerProps>`
  ${({ theme }) => theme.typography.variants.primary.xs};

  input,
  textarea {
    ${({ theme }) => theme.typography.variants.primary.xs};
    padding: 0.625rem 0.75rem;
    width: 100%;
    border: none;
    background-color: ${({ theme }) => theme.colors.transparent};

    &:focus {
      border-bottom-color: ${({ theme }) => theme.colors['blue-darker']};
    }
  }

  label {
    color: ${({ theme, color = 'black' }) => theme.colors[color]};
  }

  .Select__control {
    border: none;
    border-bottom: 1px solid
      ${({ showError, theme, color = 'gray' }) =>
        showError ? theme.colors.red : theme.colors[color]};
    border-radius: 0;
    background-color: ${({ theme }) => theme.colors.transparent};

    &:focus {
      border: none;
      border-bottom: 1px solid
        ${({ theme, color = 'blue-darker' }) => theme.colors[color]};
      box-shadow: none;
    }
  }

  .Select__control--is-focused {
    border: none;
    border-bottom: 1px solid
      ${({ theme, color = 'blue-darker' }) => theme.colors[color]};
    box-shadow: none;
  }

  .Select__placeholder,
  .Select__single-value {
    ${({ theme }) => theme.typography.variants.primary.xs};
  }

  .Select__placeholder {
    color: ${({ theme, color = 'gray-dark' }) => theme.colors[color]};
    margin-left: 0;
    margin-right: 0;
  }

  .Select__single-value {
    color: ${({ theme, color = 'black' }) => theme.colors[color]};
  }

  .Select__value-container {
    padding: 0.625rem 0.75rem;
  }

  .Select__indicator-separator {
    display: none;
  }

  .Select__menu {
    border-radius: 0;
    border: solid 1px ${({ theme, color = 'gray' }) => theme.colors[color]};
    box-shadow: none;
  }

  .Select__option {
    ${({ theme }) => theme.typography.variants.primary.xs};
    color: ${({ theme }) => theme.colors.black};
  }

  .Select__option--is-focused,
  .Select__option--is-selected {
    background-color: ${({ theme }) => theme.colors['gray-lightest']};
    color: ${({ theme }) => theme.colors.black};

    &:focus,
    &:active {
      background-color: ${({ theme }) => theme.colors['gray-lightest']};
    }
  }

  .Select__dropdown-indicator {
    color: ${({ theme, color = 'gray' }) => theme.colors[color]};
  }

  [data-whatintent='mouse'] .Select__control--is-focused {
    box-shadow: none;
  }

  [data-whatintent='touch'] .Select__control--is-focused {
    box-shadow: none;
  }
`;
